<div class="page-content container">
  <div class="page-header">
    <h1>{{ translationManager.getTranslation('bob_label_6343dd453eb5e395d849b6cf') }}{{customHeaderText}}</h1>
  </div>
  <div class="page-data shadow-sm">
    <div class="page-part">
      <div class="alert alert-info"><span><i
            class="fa fa-info-circle"></i>{{ translationManager.getTranslation('Страница за приказ понуда') }}</span>
      </div>
    </div>
    <div class="page-part">
      <div class="page-actions">
        <button class="btn btn-warning fl amno" (click)="navigateToBack()">
          <i class="fa fa-arrow-left mr-2"></i>{{ translationManager.getTranslation('Назад') }}</button>
        <button class="btn btn-success" (click)="routerNavigateToCreate()"
          *ngIf="requestRoundStatusUniqueIdentifier == 'Initiated' && items && items.length == 0"><i
            class="fa fa-plus mr-1"></i> {{ translationManager.getTranslation('SupplierOffer_NewBtn') }}</button>
      </div>

    </div>
    <div class="app-table-panel" app-table>
      <div class="app-table-used-filters">
        <div class="app-table-used-filters-title">
          <span>{{ translationManager.getTranslation('Искоришћени филтери') }}</span></div>
        <div class="app-table-used-filter-items" search-tags>
          <div class="app-table-used-filter-items-no-content" search-tag-no-content>
            <span>{{ translationManager.getTranslation('Без искоришћених филтера') }}</span></div>
          <div class="app-table-used-filter-item" style="display: none" search-tag-prototype><span><i
                search-tag-prototype-title></i><i class="app-table-used-filter-item-value"
                search-tag-prototype-value></i></span><a href="javascript:;"
              [title]="translationManager.getTranslation('Обрисати филтер')" search-tag-prototype-close><i
                class="fas fa-times"></i></a></div>
          <div class="app-table-used-filter-item app-table-used-filter-item-order" style="display: none"
            order-tag-prototype><span><i order-tag-prototype-title></i><i class="app-table-used-filter-item-value"
                order-tag-prototype-value></i></span><a href="javascript:;"
              [title]="translationManager.getTranslation('Обрисати филтер')" order-tag-prototype-close><i
                class="fas fa-times"></i></a></div>
        </div>
      </div>
      <div class="app-table-filter-panel" filter>
        <div class="app-table-filter-icon"><a href="javascript:;"
            [title]="translationManager.getTranslation('Филтрирај ентитете')" filter-open><i
              class="fas fa-filter"></i></a></div>
        <div class="app-table-filter">
          <div class="app-table-filter-search">
            <div class="app-table-filter-title"><span>{{ translationManager.getTranslation('Филтери') }}</span><a
                href="javascript:;" [title]="translationManager.getTranslation('Затвори филтер')" filter-close><i
                  class="fas fa-times"></i></a></div>
            <div class="page-part">
              <div class="alert alert-info"><span><i
                    class="fa fa-info-circle"></i>{{ translationManager.getTranslation('Доступни филтери за процес филтрирања података') }}</span>
              </div>
            </div>
            <div class="page-part">
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('att_label_6343dde03eb5e395d849b6d3')}}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="Id"
                    [search-title-new]="translationManager.getTranslation('att_label_6343dde03eb5e395d849b6d3')"
                    search-action="equals">
                </div>
              </div>
            </div>
            <div class="page-part">
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('att_label_6343de293eb5e395d849b6d4')}}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="RequestName"
                    [search-title-new]="translationManager.getTranslation('att_label_6343de293eb5e395d849b6d4')"
                    search-action="contains">
                </div>
              </div>
            </div>
            <div class="page-part">
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('att_label_6343de533eb5e395d849b6d5')}}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="TotalPriceV1"
                    [search-title-new]="translationManager.getTranslation('att_label_6343de533eb5e395d849b6d5')"
                    search-action="equals">
                </div>
              </div>
            </div>
            <div class="page-part">
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('att_label_6343de553eb5e395d849b6d6')}}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="TotalPriceV2"
                    [search-title-new]="translationManager.getTranslation('att_label_6343de553eb5e395d849b6d6')"
                    search-action="equals">
                </div>
              </div>
            </div>
            <div class="page-part">
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('att_label_6343de583eb5e395d849b6d7')}}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="TotalPriceV3"
                    [search-title-new]="translationManager.getTranslation('att_label_6343de583eb5e395d849b6d7')"
                    search-action="equals">
                </div>
              </div>
            </div>
            <div class="page-part">
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('att_label_6343de5b3eb5e395d849b6d8')}}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="TotalPriceV4"
                    [search-title-new]="translationManager.getTranslation('att_label_6343de5b3eb5e395d849b6d8')"
                    search-action="equals">
                </div>
              </div>
            </div>
            <div class="page-part">
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('att_label_6343de5d3eb5e395d849b6d9')}}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="TotalPriceV5"
                    [search-title-new]="translationManager.getTranslation('att_label_6343de5d3eb5e395d849b6d9')"
                    search-action="equals">
                </div>
              </div>
            </div>
            <div class="page-part">
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('att_label_6343e35c3eb5e395d849b6da')}}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="Currency"
                    [search-title-new]="translationManager.getTranslation('att_label_6343e35c3eb5e395d849b6da')"
                    search-action="contains">
                </div>
              </div>
            </div>
            <div class="page-part">
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('att_label_6343e39f3eb5e395d849b6db')}}</label>
                <div class="app-form-element-content">
                  <input type="date" search-input search-entity="CompletionDeadline"
                    [search-title-new]="translationManager.getTranslation('att_label_6343e39f3eb5e395d849b6db')"
                    search-action="equals">
                </div>
              </div>
            </div>
            <div class="page-part" hidden>
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('Исправност понуде')}}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="OfferCorrectness"
                    [search-title-new]="translationManager.getTranslation('Исправност понуде')"
                    search-action="contains">
                </div>
              </div>
            </div>
            <div class="page-part">
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('SupplerOfferList1200_RequestRoundSupplierStatusName')}}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="RequestRoundSupplierStatusName"
                    [search-title-new]="translationManager.getTranslation('SupplerOfferList1200_RequestRoundSupplierStatusName')"
                    search-action="contains">
                </div>
              </div>
            </div>

            <div class="app-form-element-buttons">
              <button class="btn btn-success" do-search><i
                  class="fa fa-check mr-2"></i>{{ translationManager.getTranslation('Филтрирај') }}</button>
              <button class="btn btn-danger" reset-search><i
                  class="fa fa-times mr-2"></i>{{ translationManager.getTranslation('Поништи') }}</button>
            </div>
          </div>
        </div>
      </div>
      <div class="app-table">
        <table class="table table-striped text-dark-m1">
          <thead>
            <tr class="bgc-primary-tp2 text-white">
              <th>
                <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање') " order
                  order-entity="Id">
                  {{translationManager.getTranslation('att_label_6343dde03eb5e395d849b6d3')}}
                </a>
              </th>
              <th>
                <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање') " order
                  order-entity="RequestName">
                  {{translationManager.getTranslation('att_label_6343de293eb5e395d849b6d4')}}
                </a>
              </th>
              <th>
                <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање') " order
                  order-entity="TotalPriceVersion1">
                  {{translationManager.getTranslation('att_label_6343de533eb5e395d849b6d5')}}
                </a>
              </th>
              <th>
                <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање') " order
                  order-entity="TotalPriceVersion2">
                  {{translationManager.getTranslation('att_label_6343de553eb5e395d849b6d6')}}
                </a>
              </th>
              <th>
                <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање') " order
                  order-entity="TotalPriceVersion3">
                  {{translationManager.getTranslation('att_label_6343de583eb5e395d849b6d7')}}
                </a>
              </th>
              <th>
                <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање') " order
                  order-entity="TotalPriceVersion4">
                  {{translationManager.getTranslation('att_label_6343de5b3eb5e395d849b6d8')}}
                </a>
              </th>
              <th>
                <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање') " order
                  order-entity="TotalPriceVersion5">
                  {{translationManager.getTranslation('att_label_6343de5d3eb5e395d849b6d9')}}
                </a>
              </th>
              <th>
                <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање') " order
                  order-entity="Currency">
                  {{translationManager.getTranslation('att_label_6343e35c3eb5e395d849b6da')}}
                </a>
              </th>
              <th>
                <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање') " order
                  order-entity="CompletionDeadline">
                  {{translationManager.getTranslation('att_label_6343e39f3eb5e395d849b6db')}}
                </a>
              </th>
              <th>
                <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање') " order
                  order-entity="OfferCorrectness">
                  {{translationManager.getTranslation('Исправност понуде')}}
                </a>
              </th>
              <th>
                <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање') " order
                  order-entity="RequestRoundSupplierStatusName">
                  {{translationManager.getTranslation('SupplerOfferList1200_RequestRoundSupplierStatusName')}}
                </a>
              </th>

              <th style="width: 100px" class="right">{{ translationManager.getTranslation('Акције') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of items">
              <td>{{item.supplierOfferId}}</td>
              <td>{{item.requestName}}</td>
              <td>
                <p-inputNumber [(ngModel)]="item.totalPriceV1" mode="decimal" [locale]="localeService.locale()"
                  [minFractionDigits]="2" InputFloatNumber=true [disabled]="true" inputStyleClass="textRight">
                </p-inputNumber>
              </td>
              <td>
                <p-inputNumber [(ngModel)]="item.totalPriceV2" mode="decimal" [locale]="localeService.locale()"
                  [minFractionDigits]="2" InputFloatNumber=true [disabled]="true" inputStyleClass="textRight">
                </p-inputNumber>
              </td>
              <td>
                <p-inputNumber [(ngModel)]="item.totalPriceV3" mode="decimal" [locale]="localeService.locale()"
                  [minFractionDigits]="2" InputFloatNumber=true [disabled]="true" inputStyleClass="textRight">
                </p-inputNumber>
              </td>
              <td>
                <p-inputNumber [(ngModel)]="item.totalPriceV4" mode="decimal" [locale]="localeService.locale()"
                  [minFractionDigits]="2" InputFloatNumber=true [disabled]="true" inputStyleClass="textRight">
                </p-inputNumber>
              </td>
              <td>
                <p-inputNumber [(ngModel)]="item.totalPriceV5" mode="decimal" [locale]="localeService.locale()"
                  [minFractionDigits]="2" InputFloatNumber=true [disabled]="true" inputStyleClass="textRight">
                </p-inputNumber>
              </td>

              <td>{{item.currency}}</td>
              <td>{{item.completionDeadline| appdate}}</td>
              <td>{{item.offerCorrectness}}</td>
              <td>{{item.requestRoundSupplierStatusName}}</td>
              <td class="right">
                <div class="table-actions">

                  <a *ngIf="item.requestRoundSupplierStatusUniqueIdentifier != 'AttendanceCancelled'"
                    [routerLink]="['../details', item.supplierOfferId]"
                    [title]="translationManager.getTranslation('Детаљи')">
                    <i class="far fa-file"></i>
                  </a>

                  <a *ngIf="checkStatusUniqueIdentifier(item.statusUniqueIdentifier) &&
                          checkCompletionDate(item.completionDeadline) &&
                          (
                            item.requestRoundSupplierStatusUniqueIdentifier === 'AttendanceRequested' ||
                            item.requestRoundSupplierStatusUniqueIdentifier === 'AttendanceConfirmed' ||
                            item.requestRoundSupplierStatusUniqueIdentifier === 'OfferSubmitted'
                          )" [routerLink]="['../edit', requestRoundSupplierId, item.supplierOfferId]"
                    [title]="translationManager.getTranslation('Измена')">
                    <i class="far fa-file-alt"></i>
                  </a>

                  <a *ngIf="item.statusUniqueIdentifier == 'Submitted' &&
                          requestRoundStatusUniqueIdentifier == 'Initiated' &&
                          checkCompletionDate(item.completionDeadline) &&
                          item.requestRoundSupplierStatusUniqueIdentifier === 'OfferSubmitted'
                          " href="javascript:;" (click)="showModalReturnInProgress(item.supplierOfferId)"
                    [title]="translationManager.getTranslation('Одустанак од слања понуде')">
                    <i class="fa-solid fa-plane-slash"></i>
                  </a>

                  <a *ngIf="item.statusUniqueIdentifier == 'InProgress' &&
                          requestRoundStatusUniqueIdentifier == 'Initiated' &&
                          checkCompletionDate(item.completionDeadline) &&
                          (
                            item.requestRoundSupplierStatusUniqueIdentifier === 'AttendanceRequested' ||
                            item.requestRoundSupplierStatusUniqueIdentifier === 'AttendanceConfirmed' ||
                            item.requestRoundSupplierStatusUniqueIdentifier === 'OfferSubmitted'
                          )" href="javascript:;" (click)="showSendModalFor(item.supplierOfferId)"
                    [title]="translationManager.getTranslation('Пошаљи понуду')">
                    <i class="fa-solid fa-plane"></i>
                  </a>

                  <a *ngIf="item.statusUniqueIdentifier == 'InProgress' &&
                          requestRoundStatusUniqueIdentifier == 'Initiated'&&
                          (
                            item.requestRoundSupplierStatusUniqueIdentifier === 'AttendanceRequested' ||
                            item.requestRoundSupplierStatusUniqueIdentifier === 'AttendanceConfirmed'
                          )" href="javascript:;" (click)="showDeleteModalFor(item.supplierOfferId)" class="red"
                    [title]="translationManager.getTranslation('Брисање')">
                    <i class="far fa-trash-alt"></i>
                  </a>

                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="no-content" *ngIf="!items || items.length == 0">
          <span>{{ translationManager.getTranslation('Без података') }}</span></div>
      </div>
      <div class="app-table-pagination">
        <div>
          <div pagination><span>{{ translationManager.getTranslation('Страна') }}</span><select pagination-pages>
              <option>1</option>
            </select><span>{{ translationManager.getTranslation('од') }}</span><span
              pagination-pages-count>-</span><span class="app-table-pagination-arrows"><a href="javascript:;"
                [title]="translationManager.getTranslation('Иди на почетак')" pagination-first-page><i
                  class="fas fa-angle-double-left"></i></a><a href="javascript:;"
                [title]="translationManager.getTranslation('Претходна')" pagination-previous-page><i
                  class="fas fa-angle-left"></i></a></span><span class="app-table-pagination-arrows"><a
                href="javascript:;" [title]="translationManager.getTranslation('Следећа')" pagination-next-page><i
                  class="fas fa-angle-right"></i></a><a href="javascript:;"
                [title]="translationManager.getTranslation('Иди на крај')" pagination-last-page><i
                  class="fas fa-angle-double-right"></i></a></span><span>{{ translationManager.getTranslation('Број редова за приказ') }}</span><select
              pagination-sizes>
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select></div>
        </div>
        <div class="app-table-pagination-sizes">
          <div><span>{{ translationManager.getTranslation('Укупан број слогова') }}</span><span
              pagination-total-count>-</span></div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-modal [show]="showDeleteModal" [title]="translationManager.getTranslation('Брисање')">
  <div class="app-modal-content">
    <label>{{ translationManager.getTranslation('Да ли сте сигурни да желите да обришете понуду?') }}</label></div>
  <div class="app-modal-actions">
    <button class="btn btn-success" (click)="delete()"><i
        class="fa fa-check mr-2"></i>{{ translationManager.getTranslation('Да') }}</button>
    <button (click)="showDeleteModal = false" class="btn btn-warning"><i
        class="fa fa-times mr-2"></i>{{ translationManager.getTranslation('Не') }}</button>
  </div>
</app-modal>


<app-modal [show]="displaySendModal" [title]="translationManager.getTranslation('Слање понуде')">
  <div class="app-modal-content">
    <label>{{ translationManager.getTranslation('SupplierOfferList_SendQuestion') }}</label></div>
  <div class="app-modal-actions">
    <button class="btn btn-success" (click)="send()"><i
        class="fa fa-check mr-2"></i>{{ translationManager.getTranslation('Да') }}</button>
    <button (click)="displaySendModal = false" class="btn btn-warning"><i
        class="fa fa-times mr-2"></i>{{ translationManager.getTranslation('Не') }}</button>
  </div>
</app-modal>

<app-modal [show]="displayReturnInProgress" [title]="translationManager.getTranslation('Одустанак од слања понуде')">
  <div class="app-modal-content">
    <label>{{ translationManager.getTranslation('Да ли сте сигурни да желите да одустанете од понуде?') }}</label></div>
  <div class="app-modal-actions">
    <button class="btn btn-success" (click)="sendReturnInProgress()"><i
        class="fa fa-check mr-2"></i>{{ translationManager.getTranslation('Да') }}</button>
    <button (click)="displayReturnInProgress = false" class="btn btn-warning"><i
        class="fa fa-times mr-2"></i>{{ translationManager.getTranslation('Не') }}</button>
  </div>
</app-modal>
